module.exports = __webpack_public_path__ + "media/images/flags/4x3/umi-c6387424b1ad5f914f4db5156b90e581.svg";